import { render } from "./CreatePaymentLiquidation4.vue?vue&type=template&id=6522edcd"
import script from "./CreatePaymentLiquidation4.vue?vue&type=script&lang=js"
export * from "./CreatePaymentLiquidation4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__